import { createSlice } from "@reduxjs/toolkit";
import { ROOM_SWITCH_TYPES } from "./types";

const initialState = {
  createForm: {
    name: "",
    engName: "",
    isRequirePassword: false,
    password: "",
    isRequireMinimumBalance: false,
    minimumBalance: 0,
  },
  updateForm: {
    id: null,
    name: "",
    engName: "",
    isRequirePassword: false,
    password: "",
    isRequireMinimumBalance: false,
    minimumBalance: 0,
  },
  isEdit: false,
  isOpenModal: false,
  isOpenBugModal: false,
  openBugForm: { id: "", isBugOpen: false },
};

const roomSlice = createSlice({
  name: "room",
  initialState,
  reducers: {
    onChangeRoomForm: (state, { payload }) => {
      if (state.isEdit) {
        state.updateForm = {
          ...state.updateForm,
          name: payload.name,
          engName: payload.engName,
          password: payload.password,
          minimumBalance: payload.minimumBalance,
        };
      } else {
        state.createForm = {
          ...state.createForm,
          name: payload.name,
          engName: payload.engName,
          password: payload.password,
          minimumBalance: payload.minimumBalance,
        };
      }
    },
    setIsEditRoom: (state, { payload }) => {
      state.isEdit = payload;
    },
    setUpdateRoom: (state, { payload }) => {
      state.isEdit = true;
      state.updateForm = payload;
    },
    clearRoomForm: (state) => {
      state.createForm = initialState.createForm;
      state.updateForm = initialState.updateForm;
    },
    toggleRoomModal: (state) => {
      state.isOpenModal = !state.isOpenModal;
    },
    toggleSwitch: (state, { payload }) => {
      const { type } = payload;
      switch (type) {
        case ROOM_SWITCH_TYPES.PASSWORD:
          if (state.isEdit) {
            state.updateForm = {
              ...state.updateForm,
              isRequirePassword: !state.updateForm.isRequirePassword,
            };
          } else {
            state.createForm = {
              ...state.createForm,
              isRequirePassword: !state.createForm.isRequirePassword,
            };
          }
          break;
        case ROOM_SWITCH_TYPES.MINIMUM_BALANCE:
          if (state.isEdit) {
            state.updateForm = {
              ...state.updateForm,
              isRequireMinimumBalance:
                !state.updateForm.isRequireMinimumBalance,
            };
          } else {
            state.createForm = {
              ...state.createForm,
              isRequireMinimumBalance:
                !state.createForm.isRequireMinimumBalance,
            };
          }
          break;
        default:
          break;
      }
    },
    toggleBugModal: (state) => {
      state.isOpenBugModal = !state.isOpenBugModal;
    },
    setBugForm: (state, { payload }) => {
      state.openBugForm = { id: payload.id, isBugOpen: payload.isBugOpen };
    },
    onChangeBugForm: (state) => {
      state.openBugForm = {
        ...state.openBugForm,
        isBugOpen: !state.openBugForm.isBugOpen,
      };
    },
  },
});

export const {
  onChangeRoomForm,
  setIsEditRoom,
  setUpdateRoom,
  clearRoomForm,
  toggleRoomModal,
  toggleSwitch,
  toggleBugModal,
  setBugForm,
  onChangeBugForm,
} = roomSlice.actions;

export default roomSlice.reducer;
